import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0281047c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4 max-w-4xl mx-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold mb-6" }, "VS Code Keyboard Shortcuts for Windows/Linux & macOS", -1))
const _hoisted_3 = { class: "overflow-x-auto" }
const _hoisted_4 = { class: "min-w-full table-auto text-left border-collapse border border-gray-400" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "bg-gray-200" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 p-2" }, "Action"),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 p-2" }, "Windows/Linux"),
    /*#__PURE__*/_createElementVNode("th", { class: "border border-gray-300 p-2" }, "macOS")
  ])
], -1))
const _hoisted_6 = { class: "border border-gray-300 p-2" }
const _hoisted_7 = { class: "border border-gray-300 p-2" }
const _hoisted_8 = { class: "border border-gray-300 p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.hotkeys, (action) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: action.description,
              class: "hover:bg-gray-100"
            }, [
              _createElementVNode("td", _hoisted_6, _toDisplayString(action.description), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(action.winLinux), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(action.mac), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}